import { render, staticRenderFns } from "./FiltersPaginated.vue?vue&type=template&id=0f379a0c&scoped=true&"
import script from "./FiltersPaginated.vue?vue&type=script&lang=js&"
export * from "./FiltersPaginated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f379a0c",
  null
  
)

export default component.exports